import {
    queryBot2Many,
} from 'boot/axios';
import { PROVIDERS_LIST } from 'src/mixins/providers';

const providersService = {
    providers: [],
    init: async () => {
        // providersService.providers = await queryMany('select code as value, shortTitle as label from providers order by shortTitle');
        providersService.providers = await queryBot2Many('get-providers');
        PROVIDERS_LIST.splice(0, PROVIDERS_LIST.length);
        if (providersService.providers?.length) {
            providersService.providers.forEach((i) => {
                PROVIDERS_LIST.push(i);
            });
        }
    },
    list: () => providersService.providers,
};

export default providersService;
